/**
 * Hàm check guard từng router
 * @param {*} to
 * @param {*} from
 * @param {*} next
 * HCPHI (15.09.2021)
 */
export default function guardRoute(to, from, next, subSytem, listPermission) {
  Vue.prototype.$Permission.guardRoute(
    to,
    from,
    next,
    subSytem,
    listPermission,
    null,
    store.getters.getListRole
  );
}

import Vue from "vue";
import store from "@/stores/store";
